import {configureStore} from '@reduxjs/toolkit'
import {combineReducers} from 'redux'
import { persistReducer, persistStore } from 'redux-persist'
// import storage from 'redux-persist/lib/storage'
import authenticationReducer from './reducer/authentication.reducer'
// import authReducer from './reducer/authReducer'
import leftMenuReducer from './reducer/leftMenu.reducer'
import pageReducer from './reducer/page.reducer'
import login from './reducer/login.reducer'
import localforage from 'localforage'
import globalMultipleSearchSelectReducer from './reducer/globalMultipleSearchSelect.reducer'
import globalDropdownSearchReducer from './reducer/globalDropdownSearch..reducer'
import globalDDLReducer from './reducer/globalDDL.reducer'
import globalColumnSelecttionReportReducer from './reducer/globalColumnSelecttionReport.reducer'
import globalMultipleSelectReducer from './reducer/globalMultipleSelect.reducer'
import globalErrorsReducers from './reducer/globalErrors.reducers'

const rootReducer = combineReducers({
  // auth: authReducer,
  page: pageReducer,
  auth: authenticationReducer,
  leftMenu: leftMenuReducer,
  login: login,
  globalMSS: globalMultipleSearchSelectReducer,
  globalDDS: globalDropdownSearchReducer,
  globalDDL: globalDDLReducer,
  globalColumnSelection: globalColumnSelecttionReportReducer,
  globalMultipleSelectValues: globalMultipleSelectReducer,
  globalErrors: globalErrorsReducers
})

const persistConfig = {
  key: 'root',
  storage: localforage,
  blacklist: [
    'page', 'globalMSS', 'globalDDS', 
    'globalDDL', 'globalColumnSelection', 
    'globalMultipleSelectValues', 'globalErrors']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export const persistor = persistStore(store)